import React, { Component } from 'react';
import SumaContexto from '../contexto/SumaContexto';
import { withRouter, Switch, Route } from "react-router-dom";
import { Spin } from 'antd';
import { withCookies } from 'react-cookie';
import ServicioSolicitud from '../servicios/ServicioSolicitud';
import ServicioUsuarios from '../servicios/usuarios/ServicioUsuarios';
import ServicioAdministracion from '../servicios/ServicioAdministracion';
import ListarSolicitudesDependencia from '../solicitudes-dependencia/ListarSolicitudesDependencia';
import VerSolicitud from '../mis-solicitudes/VerSolicitud';
import EstilosGlobales from '../utilidades/EstilosGlobales';
import Constantes from '../utilidades/Constantes';

class Solicitudes extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
        NO_HABILITADO: 4,
    }

    PATHS = {
        SOLICITUDES: '/solicitudes',
    }

    state = {
        componente: this.ENUM_COMPONENTE.CARGANDO,
        codigoSolicitud: null,
    };

    constructor(props) {
        super(props);
        this.historyLocal = props.history;
        this.servicioSolicitud = new ServicioSolicitud(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);
    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario sea de tipo ENTIDAD
        let usr = await this.servicioAdministracion.usuarioValido();
        if (usr !== null) {
            // Valida que tenga la accion habilitada de acceder 
            let habilitado = await this.servicioUsuarios.accionHabilitadaPromesa(Constantes.ENUMS_MODULOS.SOLICITUDES.ACCIONES.ACCEDER_MODULO_SOLICITUDES.id);
            if (habilitado && habilitado.resultado) {
                this.setState({ usuario: usr, componente: this.ENUM_COMPONENTE.VER });
            }else{
                this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_HABILITADO }); 
            }
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
    }


    clickVerSolicitud = (e, codigoSolicitud) => {
        this.setSumaState({ codigoSolicitud: codigoSolicitud });
    }

    render() {

        const { componente, codigoSolicitud } = this.state;

        return (
            <>
                <EstilosGlobales.SOLICITUDES_DEPENDENCIA />
                <div className="seccion-principal contenedor-completo seccion-flex ">

                    <div className="division-principal">
                        <label>Solicitudes</label>
                    </div>
                    <div className="division-contenido seccion-flex-grow-1 padding-principal bkg-white contenido-solicitudes">

                        {(componente === this.ENUM_COMPONENTE.VER) ?
                            (
                                <>
                                    <Switch>
                                        <Route path={this.PATHS.SOLICITUDES}>
                                            <ListarSolicitudesDependencia callbackVerSolicitud={this.clickVerSolicitud} />
                                        </Route>
                                    </Switch>

                                    {(codigoSolicitud !== null) ?
                                        <VerSolicitud codigoSolicitud={codigoSolicitud}
                                            callbackVerSolicitud={this.clickVerSolicitud} />
                                        :
                                        <></>
                                    }

                                </>
                            )
                            :
                            (
                                (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                                    (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                                    : 
                                    (
                                        (componente === this.ENUM_COMPONENTE.NO_HABILITADO ? 
                                        <label>Solicitudes no disponible. {Constantes.MENSAJE_USUARIO_SIN_PERMISOS}</label> :
                                        (componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:SOLICITUDES]</label>) : (<></>))
                                    )
                            )
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(withCookies(Solicitudes));